import React, { Component } from 'react';
import Particles from 'react-particles-js';
import galaxy from '../galaxy.jpg';
import anime from 'animejs';
import 'animate.css/animate.min.css';

class Home extends Component {
  componentDidMount() {
    let logo = anime.timeline({});
    let name = document.querySelector('.name');
    let phone = document.querySelector('.phone');
    let email = document.querySelector('.email');
    let accounts = document.querySelector('.accounts');
    logo
      .add({
        targets: '.logo .lines path',
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeInOutSine',
        duration: 200,
        delay: function(el, i) {
          return i * 250;
        },
        direction: 'alternate'
      })
      .add({
        targets: '.logo .lines g',
        fill: '#0070bc',
        offset: '+=100',
        easing: 'easeInOutSine',
      })
      // .add({
      //   targets: '.logo svg',
      //   width: '200px',
      //   duration: 800,
      //   easing: 'easeInSine',
      // })
      // .add({
      //   targets: '.logo',
      //   top:{
      //     value: '50px',
      //     duration: 1000,
      //   },
      //   offset: '-=800',
      //   easing: 'easeInCirc',
      //   complete:(anim)=>{
      //     accounts.classList.add('animated')
      //     accounts.classList.add('fadeInUp');
      //     name.classList.add('animated')
      //     name.classList.add('fadeInUp');
      //     phone.classList.add('animated')
      //     phone.classList.add('fadeInUp');
      //     email.classList.add('animated')
      //     email.classList.add('fadeInUp');
      //   }
      // })
  }
  
  render() {
    const params={
      particles: {
        number:{
          value: 80,
          density: {
            enable: true,
            value_area: 800
          }
        },
        opacity: {
          value: 1,
          random: false,
          anim: {
            enable: true,
            speed: 2,
            opacity_min: 0.1,
            sync: false,
            random: true,
          }
        },
        color: {
          value: "#74c0c8"
        },
        size: {
          value: 3,
          random: true,
          anim: {
            enable: false,
            speed: 40,
            size_min: 0.1,
            sync: false
          }
        },
        line_linked: {
          enable: false,
        }
      },
      move: {
        enable: true,
        speed: 3,
        direction: "none",
        random: false,
        straight: false,
        out_mode: "out",
        bounce: false,
        attract: {
          enable: true,
          rotateX: 600,
          rotateY: 2000
        }
      }
    }
    return (
      <div className="container-fluid home">
        <div className="row">
          <div className="top-container w-100">
            <Particles className="bg-particle" params={params}/>
            <div className="body container">
              <div className="wrapper row">
                <div className="logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.0"
                    width="300px"
                    height="36px"
                    viewBox="0 0 243.000000 29.000000"
                    preserveAspectRatio="xMidYMid meet"
                    className="lines"
                  >
                    <g
                      transform="translate(0.000000,29.000000) scale(0.050000,-0.050000)"
                      fill="#f9f9f9"
                      stroke="#0070bc"
                      strokeWidth="20"
                      strokeLinecap="round"
                    >
                      <path d="M20 290 c0 -167 8 -270 20 -270 12 0 20 103 20 270 0 167 -8 270 -20 270 -12 0 -20 -103 -20 -270z" />
                      <path d="M100 290 l0 -270 50 0 50 0 0 270 0 270 -50 0 -50 0 0 -270z" />
                      <path d="M240 290 l0 -270 107 0 107 0 53 255 c30 140 53 262 53 270 0 8 -72 15 -160 15 l-160 0 0 -270z" />
                      <path d="M709 485 c-8 -41 -31 -150 -51 -241 -55 -242 -68 -224 160 -224 l197 0 11 55 c15 78 6 83 -116 71 -61 -6 -110 -4 -109 6 0 10 18 95 39 188 52 227 53 220 -39 220 -76 0 -80 -3 -92 -75z" />
                      <path d="M1093 395 c-59 -297 -20 -375 186 -375 195 0 261 68 311 319 19 93 39 180 44 195 7 19 -12 26 -71 26 -89 0 -96 -13 -133 -230 -19 -118 -60 -170 -131 -170 -83 0 -89 32 -44 229 l40 171 -85 0 -85 0 -32 -165z" />
                      <path d="M1653 305 c-29 -140 -53 -262 -53 -270 0 -27 319 -16 389 13 93 39 168 232 90 232 -12 0 -3 24 20 53 114 145 39 227 -207 227 l-185 0 -54 -255z m307 135 c46 -29 -1 -89 -77 -96 -55 -6 -63 0 -63 41 0 76 67 102 140 55z m-24 -245 c-5 -37 -20 -46 -88 -51 -79 -6 -82 -4 -73 45 14 73 172 79 161 6z" />
                      <path d="M2240 550 c0 -6 -22 -115 -50 -242 -64 -297 -65 -288 21 -288 71 0 76 5 98 105 20 90 88 74 103 -25 13 -79 14 -80 101 -80 94 0 97 9 47 148 -9 28 3 53 45 90 79 71 98 199 37 260 -39 39 -402 68 -402 32z m276 -153 c9 -48 -51 -97 -118 -97 -57 0 -67 49 -23 126 16 30 134 6 141 -29z" />
                      <path d="M2709 526 c84 -204 110 -316 91 -384 -31 -113 -27 -122 58 -122 78 0 79 1 100 101 16 74 55 143 145 260 136 175 143 182 125 109 -11 -46 -7 -50 60 -50 85 0 84 3 32 -216 -51 -214 -53 -204 39 -204 88 0 80 -16 132 245 l35 175 77 0 c53 0 77 9 77 28 0 16 5 43 12 60 11 28 -24 32 -307 32 l-319 0 -72 -102 -71 -102 -29 97 c-27 95 -30 97 -114 103 -76 6 -84 2 -71 -30z" />
                      <path d="M3740 553 c0 -13 -101 -461 -113 -499 -9 -32 0 -36 75 -30 l86 6 43 210 c23 116 48 235 56 265 13 53 11 55 -67 55 -44 0 -80 -3 -80 -7z" />
                      <path d="M4038 515 c-250 -168 -177 -485 112 -485 165 0 160 -2 176 82 l12 61 -134 -1 c-133 -2 -134 -2 -141 55 -17 152 87 240 238 200 77 -21 141 51 105 118 -21 38 -300 15 -368 -30z" />
                      <path d="M4478 502 c-104 -105 -73 -203 87 -269 56 -23 71 -39 62 -64 -13 -34 -128 -34 -210 0 -33 14 -77 -96 -50 -123 54 -53 318 -23 385 44 93 93 33 270 -92 270 -19 0 -46 13 -60 30 -34 41 17 59 129 43 89 -12 110 7 111 102 0 59 -297 31 -362 -33z" />
                    </g>
                  </svg>
                </div>
                {
                  // <div className="accounts col-12">
                  //   <div className="row flex-column justify-content-center align-items-center text-left">
                  //     <h3 className="job pr-0 pl-2 col-12 col-md-6 col-lg-4">Project Leader</h3>
                  //     <div className="pr-0 pl-2 col-12 col-md-6 col-lg-4">
                  //       <div className="contact text-left">
                  //         <p className="name">Hồ Thy An</p>
                  //         <p className="phone">(+84) 169 367 2202</p>
                  //         <p className="email">thyan.ho@lubrytics.com</p>
                  //       </div>
                  //     </div>
                  //   </div>
                  // </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home.js